module.exports = __webpack_public_path__ + "img/my03.7b3dbe27.jpg";